module.exports = __webpack_public_path__ + "static/media/home.c3f58554.svg";